// PrivateRouter.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '../stores';
import { observer } from 'mobx-react';

const PrivateRouter = observer(({ children }) => {
  const { authStore } = useStore();

  // If auth is still being restored, show nothing (parent handles loading)
  if (authStore.isRestoringAuth) {
    return null;
  }

  // If not logged in, redirect to login
  if (!authStore.isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Check if token is expired
  if (authStore.isTokenExpired && authStore.isTokenExpired()) {
    authStore.logout();
    return <Navigate to="/login?session_expired=true" replace />;
  }

  return children;
});

export default PrivateRouter;